/* eslint-disable @typescript-eslint/no-unused-vars */
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { GetVehicleMROsPaginatedResponse, VehicleMROResponse } from '../../app/features/vehicles/domain/mro-manual-model';
import { MroCVERepository } from '../../app/features/vehicles/infrastructure/mro-cve.repository';
import { VehicleMROResponseMock } from '../dataMocks/vehicle-mro-response-mock';
import { AuthenticateVehicleCveDto } from '../../app/features/vehicles/infrastructure/dto/mro-cve.dto';
import { AuthenticateLocationResponse } from '../../app/features/vehicles/domain/mro-smartcar.model';

export class MroCVEApiServiceMock implements MroCVERepository {
    cveAuth(authenticateVehicleDto: AuthenticateVehicleCveDto): Observable<AuthenticateLocationResponse> {
        return of({ location: 'location' });
    }
}
